type ErrorFallbackProps = {
  resetError?: () => void;
};

/**
 * Fallback UI shown when a React render error is caught by Sentry's
 * ErrorBoundary. The error itself has already been reported to Sentry
 * by the boundary, so no additional capture is needed here.
 */
export function ErrorFallback({ resetError }: ErrorFallbackProps) {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-8 text-center"
    >
      <h1 className="text-2xl font-semibold text-slate-900">Something went wrong</h1>
      <p className="max-w-md text-slate-600">
        We&apos;ve been notified and are looking into it. Try refreshing the page, or come back in a
        few minutes.
      </p>
      {resetError && (
        <button
          type="button"
          onClick={resetError}
          className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
        >
          Try again
        </button>
      )}
    </div>
  );
}
